import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Stack } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export default function LineChart({ data, height, width, grid = false, yGrid = false , xAxisSpace = false }) {
    const graphOptions = {
        responsive: true,
        maintainAspectRatio: false, // Disable aspect ratio to allow the chart to fill the container
        plugins: {
            legend: {
                display: false,
                position: 'top',
            },
        },
        scales: {
            x: {
                ticks: {
                    display: grid,
                },
                grid: {
                    drawBorder: grid,
                    display: false,
                    color: '#edf2f5',
                },
                border: {
                    display: true,
                    color: '#CACED0',
                },
                 offset: xAxisSpace, 

            },
            y: {
                ticks: {
                    display: grid,
                },
                grid: {
                    drawBorder: false,
                    display: false,
                    color: '#edf2f5',
                    
                },
                border: {
                    display: true,
                    color: '#CACED0',
                },
                offset : xAxisSpace,
            },
        },
    };

    return (
        <Stack sx={{ width: width, height: height }}> {/* Use dynamic height and width */}
            <Line options={graphOptions} data={data} />
        </Stack>
    );
}
